import { Serie } from "@nivo/line";
import React from "react";
import { ChartProps as ChartComponentProps } from "../Chart/Chart";
import NumberMeasurementChart from "../NumberMeasurementChart";

export interface HumidityChartProps {
  data: Serie[];
  deltaTimeInHours: number;
  legend?: string;
  unit?: string;
  displayLegends?: boolean;
  quantities?: number[];
  ChartProps?: Partial<ChartComponentProps>;
}

const HumidityChart: React.FC<HumidityChartProps> = ({
  data,
  deltaTimeInHours,
  displayLegends = false,
  quantities,
  legend = "Humidity",
  unit = "%",
  ChartProps,
}) => {
  return (
    <NumberMeasurementChart
      data={data}
      unit={unit}
      quantities={quantities}
      deltaTimeInHours={deltaTimeInHours}
      legend={legend}
      legends={
        displayLegends
          ? [
              {
                anchor: "bottom-right",
                direction: "column",
                itemWidth: 100,
                itemHeight: data.length * 15,
                translateX: 110,
              },
            ]
          : []
      }
      min={15}
      max={42}
      {...(displayLegends ? { margin: { top: 50, right: 110, bottom: 50, left: 45 } } : {})}
      {...ChartProps}
    />
  );
};

export default HumidityChart;
